import { SortDirection } from '../enums';

export interface Sort {
  sortBy: string | null;
  direction: SortDirection | null;
}

export namespace Sort {
  export const mapToApiValue = ({ sortBy, direction }: Sort): any => {
    if (!sortBy || !direction) {
      return null;
    }
    return {
      sortBy,
      direction: SortDirection.mapToApiValue(direction),
    };
  };
  export const mapToQueryParam = ({ sortBy, direction }: Sort): any => {
    if (!sortBy || !direction) {
      return null;
    }
    return `${sortBy},${SortDirection.mapToApiValue(direction)}`;
  };
}
